import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { CREATE_BENEFIT_GROUP, CREATE_BENEFIT_GROUP_SUCCESS, CREATE_BENEFIT_GROUP_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* createBenefitGroup({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefitGroups`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Benefit group created successfully!`);
      yield put({
        type: CREATE_BENEFIT_GROUP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_BENEFIT_GROUP_ERROR,
        payload: response.response.data,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_BENEFIT_GROUP_ERROR, payload: error });
  }
}

export function* watchBenefitGroup() {
  yield takeEvery(CREATE_BENEFIT_GROUP, createBenefitGroup);
}

function* creatBenefitGroupSaga() {
  yield all([fork(watchBenefitGroup)]);
}

export default creatBenefitGroupSaga;
